<!-- contact us -->
<div id="contact" class="contact" style="background-image: url(assets/image/contact-us-1.png)">
    <div class="contact-header">
      <h2>CONTACT <span>US</span></h2>
    </div>
    <div class="contact-detail">
      <div class="container">
        <div class="row">
          <div class="offset-lg-4 col-lg-8 offset-md-3 col-md-9">
            <div class="contact-form">
              <form [formGroup]="formdata"  (ngSubmit)="onClickSubmit()">
                <div class="row">
                  <div class="col-md-6">
                    <input type="text" class="form-control" placeholder="NAME" formControlName="name" />
                  </div>
                  <div class="col-md-6">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="LOCATION"
                      name=location
                     formControlName="location"
                    />
                  </div>
               
                  <div class="col-md-6">
                    <input
                      type="email"
                      class="form-control"
                      placeholder="EMAIL"
                      name="email"
                     formControlName="email"
                    />
                  </div>
                  <div class="col-md-6">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="PHONE"
                      name="phone"
                     formControlName="phone"
                    />
                  </div>
                </div>
                <textarea
                  class="form-control"
                  placeholder="MESSAGE"
                  rows="5"
                  name="message"
                 formControlName="message"
                ></textarea>
                <div class="col-md-12 mt-3" >
                  <re-captcha formControlName="recaptchaReactive" >
                  </re-captcha>
                </div>
                <div class="contact-btn">
                  <input  [disabled]="formdata.invalid" type="submit" class="contact-button" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  